import * as React from 'react';
import { SVGProps } from 'react';

const DownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.207 10.293a1 1 0 0 0-1.414 0L12 13.086l-2.793-2.793a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
export default DownArrow;
